import React, {useState, useEffect} from 'react';
import './PaiementStripe.scss';
import axios from 'axios';
import Conf from 'utils/Conf';
import CircularProgress from '@material-ui/core/CircularProgress';

import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import PaiementCheckoutForm from '../PaiementCheckoutForm';
import {withTranslation} from 'react-i18next';

const PaiementBanContact = ({t, onErreur, onOk, seance, coupon, locale, email, onClose, go}) => {
  const [paymentIntentSecret, setPaymentIntentSecret] = useState('');
  const [paymentIntentAmount, setPaymentIntentAmount] = useState('');
  const [stripePromise, setStripePromise] = useState(null);

  useEffect(() => {
    const seanceId = seance.seance_id;
    const params = coupon ? {discount_code: coupon.value} : {};
    axios
      .get(`${Conf.apiBaseUriLegacy}/stripe_paymentintent/${seanceId}/bancontact`, {params, withCredentials: true})
      .then(res => {
        if (res.data.status === 'error') {
          onErreur(t(res.data.error));
        } else {
          if (res.data.authorized === true) {
            onOk();
          } else if (res.data.authorized === false) {
            setPaymentIntentSecret(res.data.paymentIntentSecret);
            setPaymentIntentAmount(res.data.paymentIntentAmount);
            setStripePromise(loadStripe(res.data.stripeApiPk));
          } else {
            onErreur(t('quelque-chose-s-est-mal-passe-merci-d-essayer-plus-tard'));
          }
        }
      })
      .catch(() => {
        onErreur(t('probleme-de-connexion-merci-dessayer-plus-tard'));
      });
  }, [t, onErreur, onOk, seance, coupon]);

  if (!stripePromise)
    return (
      <div>
        <CircularProgress />
      </div>
    );

  return (
    <Elements stripe={stripePromise} options={{locale}}>
      <PaiementCheckoutForm
        paymentType="bancontact"
        email={email}
        paymentIntentSecret={paymentIntentSecret}
        paymentIntentAmount={paymentIntentAmount}
        go={go}
        onClose={onClose}
        seance={seance}
      />
    </Elements>
  );
};

export default withTranslation()(PaiementBanContact);
